<template>
  <body>
    <div class="sustainability">
      <div class="title">
        Stay Ahead of EU Sustainability <br />
        Regulations with Wecobi
      </div>
      <div class="images-wrapper">
        <div class="images-subwrapper">
          <div
            class="images image-one"
            @click="navigateAndScroll('/sustainability', '#difference')"
          >
            <div class="text-box text-box-one">
              <a>Optimize</a>
            </div>
          </div>
          <div
            class="images image-two"
            @click="navigateAndScroll('/sustainability', '#strategy')"
          >
            <div class="text-box text-box-one">
              <a>Maximize</a>
            </div>
          </div>
        </div>
        <div class="images-subwrapper">
          <router-link to="/learnWhy" class="images image-three">
            <div class="text-box text-box-one">
              <a>Monetize</a>
            </div>
          </router-link>
          <div
            class="images image-four"
            @click="navigateAndScroll('/sustainability', '#stepsection')"
          >
            <div class="text-box text-box-one">
              <a>Sustain</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import { nextTick } from "vue";

export default {
  name: "EuSustainability",
  methods: {
    navigateAndScroll(page, hash = null) {
      this.$router.push(page).then(() => {
        if (hash) {
          nextTick(() => {
            setTimeout(() => {
              const element = document.querySelector(hash);
              if (element) {
                const elementPosition =
                  element.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                  top: elementPosition,
                  behavior: "smooth",
                });
              } else {
                console.warn(`Element with ID ${hash} not found!`);
              }
            }, 100);
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.sustainability {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 120px 0px 120px 0px;
}
.title {
  font-size: 40px;
  font-weight: 500;
  text-align: center;
}
.images-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  flex-direction: column;
  margin-top: 70px;
}
.images-subwrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}
.images {
  width: 425px;
  height: 210px;
  border-radius: 20px;
  cursor: pointer;
}
.image-one {
  background-image: url("../../../assets/eusustainability/optimize.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.image-two {
  background: url("../../../assets/eusustainability/maximize.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.image-three {
  background-image: url("../../../assets/eusustainability/monetize.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.image-four {
  background-image: url("../../../assets/eusustainability/sustain.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.text-box {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-box-one {
  background: rgba(0, 0, 0, 0.5);
}

.text-box-one:hover {
  background: linear-gradient(
      to right,
      rgba(249, 129, 64, 0.5),
      rgba(235, 77, 191, 0.5)
    ),
    rgba(0, 0, 0, 0.2);
}

a {
  font-size: 30px;
  font-weight: 500;
  color: #ffffff;
}

@media (max-width: 1280px) {
  .sustainability {
    margin: 100px 0px 100px 0px;
  }
  .title {
    font-size: 35px;
  }
}

@media (max-width: 1028px) {
  .title {
    font-size: 30px;
  }
  .images {
    width: 360px;
    height: 160px;
  }
  a {
    font-size: 20px;
  }
}

@media (max-width: 788px) {
  .sustainability {
    margin: 80px 0px 80px 0px;
  }
  .title {
    font-size: 25px;
  }
  .images {
    width: 261px;
    height: 119px;
  }
}
@media (max-width: 600px) {
  .sustainability {
    margin: 60px 0px 60px 0px;
  }
  .images-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
</style>
